// frontend/src/App.js

import React from 'react';
import './App.css';
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Link,
  useNavigate
} from 'react-router-dom';
import {
  CssBaseline,
  AppBar,
  Toolbar,
  Typography,
  Box,
  Button
} from '@mui/material';

import Login     from './pages/Login';
import Dashboard from './pages/Dashboard';
import Upload    from './pages/Upload';
import Jobs      from './pages/Jobs';

// Simple auth check; replace with real logic later
const isAuth = () => Boolean(localStorage.getItem('auth'));

// Wrapper to protect private routes
function PrivateRoute({ children }) {
  return isAuth() ? children : <Navigate to="/login" replace />;
}

function App() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('auth');
    navigate('/login', { replace: true });
  };

  return (
    <>
      <CssBaseline />

      {/* TopBar */}
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            CoatingApp
          </Typography>
          {isAuth() && (
            <Button color="inherit" onClick={handleLogout}>
              Logout
            </Button>
          )}
        </Toolbar>
      </AppBar>

      {/* NavBar (only visible when logged in) */}
      {isAuth() && (
        <Box
          component="nav"
          sx={{ display: 'flex', bgcolor: 'grey.100', p: 1 }}
        >
          <Button component={Link} to="/"     sx={{ mr: 1 }}>Dashboard</Button>
          <Button component={Link} to="/upload" sx={{ mr: 1 }}>Upload</Button>
          <Button component={Link} to="/jobs"   sx={{ mr: 1 }}>Jobs</Button>
        </Box>
      )}

      {/* Route definitions */}
      <Routes>
        {/* Public route */}
        <Route path="/login" element={<Login />} />

        {/* Private routes */}
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/upload"
          element={
            <PrivateRoute>
              <Upload />
            </PrivateRoute>
          }
        />
        <Route
          path="/jobs"
          element={
            <PrivateRoute>
              <Jobs />
            </PrivateRoute>
          }
        />

        {/* Fallback to Dashboard */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

// Wrap App in BrowserRouter so that useNavigate() works inside App
export default function AppWrapper() {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}
